import { api } from '@/api';
import router from '@/router';
import { AxiosError } from 'axios';
import { getStoreAccessors } from 'typesafe-vuex';
import { ActionContext } from 'vuex';
import { State } from '../state';
import {
    commitSetImportantNews,
    commitSetNews,
    commitSetNewsDetailed,
} from './mutations';
import { NewsState } from './state';
import { dispatchCheckApiError } from '../main/actions';

type MainContext = ActionContext<NewsState, State>;

export const actions = {
    async actionGetImportantNews(context: MainContext) {
        try {

            const response = await api.getImportantNews(context.rootState.main.token);
            if (response.data) {
                commitSetImportantNews(context, response.data);
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },
    async actionGetNewsDetailed(context: MainContext, payload: { pk: string }) {
        try {
            const response = await api.getNewsDetailed(context.rootState.main.token, payload.pk);
            if (response.data) {
                commitSetNewsDetailed(context, response.data);
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },
    async actionGetNews(context: MainContext) {
        try {
            const response = await api.getNews(context.rootState.main.token);
            if (response.data) {
                commitSetNews(context, response.data);
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },
};

const { dispatch } = getStoreAccessors<NewsState | any, State>('');

export const dispatchGetImportantNews = dispatch(actions.actionGetImportantNews);
export const dispatchGetNewsDetailed = dispatch(actions.actionGetNewsDetailed);
export const dispatchGetNews = dispatch(actions.actionGetNews);
